import { BffBrandType, BffFacility, BffNearbyFacilitiesByLocationDocument } from '@src/lib/__generated/beffe/sdk';
import { getBeffeGraphQlClient } from '@src/lib/client';

export const getBffNearByFacilitiesByLocation = async (
	brand: BffBrandType,
	latitude: number,
	longitude: number,
	url: string,
	radiusMiles?: number
) => {
	const beffeGraphQlClient = getBeffeGraphQlClient(url);
	return beffeGraphQlClient
		.query<{ facilityByLocation: BffFacility[] }>(BffNearbyFacilitiesByLocationDocument, {
			brand,
			longitude,
			latitude,
			radiusMiles,
		})
		.toPromise();
};
